import { matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  TransactionDetailMatchParams,
  transactionDetailRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectUploadingAttachmentsFromState = (
  state: RootState,
): Record<string, string> =>
  state.app.transactionDetail.uploadingAttachmentThumbnails

export const selectFailedUploadThumbnailsFromState = (
  state: RootState,
): Record<string, string> => state.app.transactionDetail.failedUploadThumbnails

export const selectRecentlyUploadedAttachmentIdsFromState = (
  state: RootState,
): Set<string> => state.app.transactionDetail.recentlyUploadedAttachmentIds

/**
 * Assumes that you are on a URL with a transaction ID in the path
 * @return transaction ID from URL or empty string if not found
 */
export const selectTransactionIdFromPathState = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<TransactionDetailMatchParams>(
      location.pathname,
      transactionDetailRouteProps,
    )
    return mtch?.params.id ?? ''
  },
)

export const selectTransactionAttachmentIdFromState = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<TransactionDetailMatchParams>(
      location.pathname,
      transactionDetailRouteProps,
    )
    return mtch?.params.attachmentId
  },
)
